import ImageItem from 'rlink-media/ImageItem';

export default class Profile extends ImageItem {
  get adminLabel () {
    return this.title.length > 0 ? this.title : '<untitled profile slide>';
  }

  get mainImageFormats () {
    return {
      src: this.imagePath,
      formats: [
        {contentType: 'image/webp', fileExt: 'webp'},
        {contentType: 'image/jpeg', fileExt: 'jpg'},
      ],
      widths: [
        640, 480, 341, 213,
      ],
    };
  }

  get name () {
    return this.data.get('name', '');
  }

  get jobTitle () {
    return this.data.get('jobTitle', '');
  }

  get description () {
    return this.data.get('description', '');
  }

  get linkedIn () {
    return this.data.get('linkedIn', '');
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/content-types/Profile.js